import { render } from "./LiveSessionsFeedback.vue?vue&type=template&id=ff9c9f0a"
import script from "./LiveSessionsFeedback.vue?vue&type=script&lang=js"
export * from "./LiveSessionsFeedback.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__